var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"icon es-icon",class:[{ spin: _vm.spin }, _vm.size],domProps:{"innerHTML":_vm._s(_vm.getSvg())}})
}
var staticRenderFns = []

export { render, staticRenderFns }